export const LOAN_APPLICATION_LINKS = [
  { id: "all", segment: "", label: "All Applications" },
  { id: "new", segment: "new", label: "New Application" },
  { id: "groups", segment: "groups", label: "Group Applications" },
  { id: "drafts", segment: "drafts", label: "Draft Applications" },
  { id: "pending", segment: "pending", label: "Pending Applications" },
  { id: "approved", segment: "approved", label: "Approved" },
  { id: "rejected", segment: "rejected", label: "Rejected" },
];

/** URL segments under /credora/loans/:segment (not theme layout slugs). */
export const LOAN_APPLICATION_ROUTE_SEGMENTS = new Set(
  LOAN_APPLICATION_LINKS.map((link) => link.segment).filter(Boolean)
);

export function loanApplicationPath(pub, layoutURL, segment = "") {
  const base = `${pub}/credora/loans`;
  return segment ? `${base}/${segment}/${layoutURL}` : `${base}/${layoutURL}`;
}
